<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="process"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import Service from '@/services/api/publicPortal.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';
export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Cuestionarios Satisfacción de Transportación ',
      routes: ['Informes', 'Cuestionarios Satisfacción de Transportación '],
    },
    model: {
      search: {
        collections: {
          academicYearList: [],
          semesterList: [],
          areaList: [],
          questionnaireType: [],
          servicesTypeList: [],
        },
        filters: {
          academicYear: null,
          semester: null,
          area: null,
          questionnaireType: null,
          serviceType: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          clearable: false,
          options: this.model.search.collections.academicYearList,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
          class: 'col-md-3',
          validations: 'required',
          error: 'Favor seleccionar Año Académico',
        },
        {
          name: 'area',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: '  Área',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.areaList,
          value: this.model.search.filters.area,
          class: 'col-md-3',
          onChanged: this.onChangeMonth,
          validations: 'required',
          error: 'Favor seleccionar Área',
        },

        {
          name: 'semester',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Semestre',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.semesterList,
          value: this.model.search.filters.semester,
          class: 'col-md-3',
          onChanged: this.onChangeProvider,
          validations: 'required',
          error: ' Favor seleccionar Semestre',
        },
        {
          name: 'questionnaireType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Cuestionario',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.questionnaireType,
          value: this.model.search.filters.questionnaireType,
          class: 'col-md-3',
          validations: 'required',
          error: 'Favor seleccionar Tipo de Cuestionario',
        },
        {
          name: 'serviceType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Servicio',
          error: 'Favor seleccionar Tipo de Servicio',
          validations: 'required',
          placeholder: 'Seleccionar',
          options: this.model.search.collections.servicesTypeList,
          value: this.model.search.filters.serviceType,
          class: 'col-md-3',
        },
      ];
    },
  },
  async mounted() {
    const { data } = await Service.initFilter();
    this.model.search.collections.academicYearList = data.academicYearList;
    this.model.search.collections.semesterList = data.semesterList;
    this.model.search.collections.areaList = data.areaList;
    this.model.search.collections.questionnaireType = data.questionnaireType;
    this.model.search.collections.servicesTypeList = data.servicesTypeList;
    this.model.search.filters.area = data.areaList[0];
    this.model.search.filters.questionnaireType = data.questionnaireType[0];
  },
  methods: {
    async process() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      await ReportServices.getReport('trasportationreport', {
        academicYearId: this.model.search.filters.academicYear?.id,
        AreaId: this.model.search.filters.area?.id,
        SemesterId: this.model.search.filters.semester?.id,
        SampleServiceTypeId: this.model.search.filters.serviceType?.id,
        IsTeacherType: false,
      }).then((res) => DocumentServices.Download(res.data));
    },
  },
};
</script>
